export const CONTACT_TOGGLE_LOADING = 'CONTACT_TOGGLE_LOADING'
export const CONTACT_SET_ERROR = 'CONTACT_SET_ERROR'
export const CONTACT_RESET = 'CONTACT_RESET'
